import { IAppState } from '../../redux';
import { IServicePackage } from '../../redux/reducers';

export function selectActivePackage(state: IAppState): IServicePackage | null {
  const {
    publishTerms: { packages, selectedPackageId },
  } = state;

  if (!selectedPackageId) {
    return null;
  }

  return packages[selectedPackageId];
}
